import React from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import {
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import extractPathname from '@sls-react/utils/extractPathname';
import { Link, useRouter } from '@sls-react/routing';
import { AnalyticsSource } from '@sls-react/services/analytics/AnalyticsInterfaces';
import qsUpdateString from '@sls-react/utils/qsUpdateString';
import NewTabLink from './NewTabLink';
import { RailsCartItemItem } from '@sls-react/typings/services/rails/cart';
import useItemDetailsLink, {
  ItemDetailsLinkParams,
} from '@sls-react/hooks/links/useItemDetailsLink';

type Props = AnchorProps & ItemDetailsLinkParams;

const ItemDetailsLink: React.FC<Props> = ({
  children,
  item,
  itemId,
  onClick,
  src,
  url,
  ...props
}) => {
  const itemUrl = useItemDetailsLink({
    item,
    itemId,
    src,
    url,
  });

  return (
    <a
      {...props}
      href={itemUrl}
      onClick={e => {
        if (
          window.nativeBridge &&
          typeof window.nativeBridge.viewItem == 'function' &&
          (item?.id || itemId)
        ) {
          e.preventDefault();
          e.stopPropagation();

          try {
            window.nativeBridge.viewItem(item!.id! || itemId!);
          } catch (e) {}
        } else if (onClick) {
          onClick(e);
        }
      }}
    >
      {children}
    </a>
  );
};

export default ItemDetailsLink;
